// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // The application switcher ("Aplicações", the login-farmácias mark in the header); shown in production too since 2026-10-29.
  showAppSwitcher: true,
  apiUrl: 'https://devbidscircleapi.azurewebsites.net',
  // No Microsoft Clarity outside production: empty means no script and no cookie banner (ADO #270).
  clarityProjectId: '',

  // login-farmacias SSO — the dev tenant (login-farmacias/docs/dev-tenant.md). The authority is
  // always the custom domain, never a *.ciamlogin.com host; the issuer inside the tokens is the
  // ciamlogin one and is validated from metadata, not pinned. The redirect URI is composed from
  // the current origin so one build works on localhost:4200 and on devbidscircleweb, both of
  // which are registered on the app.
  sso: {
    clientId: 'd158f776-1ce0-4361-9f3e-4a3597b729ed', // bidscircle-web
    authority: 'https://auth-dev.login-farmacias.com/b7c215d0-9891-4ba4-ae90-e032eaffacc9/v2.0',
    authorityHost: 'auth-dev.login-farmacias.com',
    redirectPath: '/account/sso-callback',
    apiScope: 'api://bidscircle/access_as_user',
    // Where a group sign-out is performed, for every application (login-farmacias spec
    // `sso-logout`). Ending the Entra session here instead would strand the portal.
    portalLogoutUri: 'https://dev.login-farmacias.com/logout',
    // The portal's origin, for the application switcher (login-farmacias change app-switcher).
    portalUri: 'https://dev.login-farmacias.com',
  },
  //apiUrl: 'https://localhost:51767'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
